
<div ref="scrollContainer">
  <slot v-for="(item, index) in itemsToDisplay" :item="item" :index="index"/>
</div>
